import React from 'react';
import { Link } from 'react-router-dom';
import * as Images from '../../../assets';

const ComingSoon = () => {
    return (
        <div className="flex justify-center items-center px-16 py-12 bg-white max-md:px-5" >
        <div className="mt-6 max-w-full w-[1296px]">
            <div 
            className='flex items-center justify-center text-8xl'
            >Coming Soon ...</div>
        </div>
    </div>
    )
}

export default ComingSoon